// src/components/QRCodeScanner.js
import { useState } from "react";
import { useZxing } from "react-zxing";

export const QRCodeScanner = ({ onScan }) => {
    const [result, setResult] = useState("");
    const { ref } = useZxing({
        onDecodeResult(result) {
            setResult(result.getText());
            onScan(result.getText()); // Pass the result to the parent component
        },
    });

    return (
        <video ref={ref} style={{ width: "100%" }} />
    );
};